import React, { useEffect, useState } from 'react';
import Typography from '@material-ui/core/Typography';

import comparingLoader from '../../comparing-loader.gif';
import { COMPARISON_ANIMATION_DELAY_MS } from '../../util/constants';

const ComparisonAnimation = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Fast comparisons finish before the animation appears, so it doesn't just flash
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), COMPARISON_ANIMATION_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) return null;

  return (
    <Typography
      component="div"
      style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}
    >
      <div>
        <img
          src={comparingLoader}
          alt=""
          style={{ width: 600, aspectRatio: '754 / 151', margin: '40px 0 20px' }}
        />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', width: 600, fontSize: 20 }}>
        <div style={{ marginLeft: 20 }}>Files</div>
        <div style={{ marginLeft: 30 }}>ExamDiff Pro</div>
        <div style={{ marginRight: 9 }}>DiffNow</div>
      </div>
    </Typography>
  );
};

export default ComparisonAnimation;
